import // SIGN_IN,
// SIGN_OUT,
// SIGN_UP,
// // FORGET_PASS,
// RESET_PASS,
// EMAIL_VERIFY,
// FACEBOOK_LOGIN,
// LINKEDIN_LOGIN,
// GOOGLE_LOGIN,
// SEND_OTP,
// SET_OTP_SENT,
"../actions/authAction";

export const FORGET_PASS = "FORGET_PASS";
export const SIGN_IN = "SIGN_IN";
export const SIGN_OUT = "SIGN_OUT";
export const SIGN_UP = "SIGN_UP";
export const RESET_PASS = "RESET_PASS";
export const CLOSE_LOADER = "CLOSE_LOADER";
export const EMAIL_VERIFY = "EMAIL_VERIFY";
export const FACEBOOK_LOGIN = "FACEBOOK_LOGIN";
export const LINKEDIN_LOGIN = "LINKEDIN_LOGIN";
export const GOOGLE_LOGIN = "GOOGLE_LOGIN";
export const SEND_OTP = "SEND_OTP";
export const SET_OTP_SENT = "SET_OTP_SENT";

import { isFulfilled, isPending, isRejected } from "./reducerUtils";

const authReducer = (
    state = {
        signInLoading: false,
        // signedIn: false,
        signUpLoading: false,
        signedUP: false,
        resetPasswordLoading: false,
        resetPassword1: false,
        emailVerifyLoading: false,
        emailVerified: false,
        emailVerificationFailed: false,
        forgetPasswordLoading: false,
        forgetPassword: false,
        facebookLoginLoading: false,
        facebookLogedIn: false,
        linkedinLoginLoading: false,
        linkedinLogedIn: false,
        linkedinLoginFailed: false,
        googleLoginLoading: false,
        googleLogedIn: false,
        otpSent: false,
        gmbAccesstoken: "",
        gmbScope: [],
        gmbExpireTime: "",
        gmbRefreshToken: "",
        gmbLocationList: [],
        gmbAddresLine: {},
        gmbAccountList: [],

        // play store authentication
        playStoreAccesstoken: "",
        playStoreScope: [],
        playStoreExpireTime: "",
        playStoreRefreshToken: "",
        playstoreClientSecret: "",

        youtubeAccesstoken: "",
        youtubeScope: [],
        youtubeExpireTime: "",
        youtubeRefreshToken: "",
        youtubeChannelLists: [],
    },
    action,
) => {
    switch (action.type) {
        // case isPending(SIGN_IN):
        //     return (state = {
        //         ...state,
        //         signInLoading: true,
        //     });
        // case isRejected(SIGN_IN):
        //     return (state = {
        //         ...state,
        //         signInLoading: false,
        //     });
        // case isFulfilled(SIGN_IN): {
        //     // if (action.payload.status === "success") {
        //     //     localStorage.setItem("accessToken", action.payload.data.accessToken);
        //     //     localStorage.setItem("userId", action.payload.data.userId);
        //     //     return (state = {
        //     //         ...state,
        //     //         signInLoading: false,
        //     //         signedIn: true,
        //     //     });
        //     // } else {
        //     //     return (state = {
        //     //         ...state,
        //     //         signInLoading: false,
        //     //         signedIn: false,
        //     //     });
        //     // }
        //     console.log(action.payload);
        //     return { ...state, signInLoading: false };
        // }
        case SIGN_OUT:
            return {
                signInLoading: false,
                signedIn: false,
            };
        case isPending(SIGN_UP):
            return (state = {
                ...state,
                signedUP: false,
                signUpLoading: true,
            });
        case isRejected(SIGN_UP):
            return (state = {
                ...state,
                signedUP: false,
                signUpLoading: false,
            });
        case isFulfilled(SIGN_UP):
            if (action.payload.status === "success") {
                return (state = {
                    ...state,
                    signedUP: true,
                    signUpLoading: false,
                });
            } else {
                return (state = {
                    ...state,
                    signedUP: false,
                    signUpLoading: false,
                });
            }

        case isPending(FORGET_PASS):
            return (state = {
                ...state,
                forgetPasswordLoading: true,
                forgetPassword: false,
            });
        case isRejected(FORGET_PASS):
            return (state = {
                ...state,
                forgetPasswordLoading: false,
                forgetPassword: false,
            });
        case isFulfilled(FORGET_PASS):
            return (state = {
                ...state,
                forgetPasswordLoading: false,
                forgetPassword: true,
            });

        case isPending(RESET_PASS):
            return (state = {
                ...state,
                resetPasswordLoading: true,
                resetPassword1: false,
            });
        case isRejected(RESET_PASS):
            return (state = {
                ...state,
                resetPasswordLoading: false,
                resetPassword1: false,
            });
        case isFulfilled(RESET_PASS):
            if (action.payload.status === "success") {
                return (state = {
                    ...state,
                    resetPasswordLoading: false,
                    resetPassword1: true,
                });
            } else {
                return (state = {
                    ...state,
                    resetPasswordLoading: false,
                    resetPassword1: false,
                });
            }
        case isPending(EMAIL_VERIFY):
            return (state = {
                ...state,
                emailVerifyLoading: true,
                emailVerified: false,
            });
        case isRejected(EMAIL_VERIFY):
            return (state = {
                ...state,
                emailVerifyLoading: false,
                emailVerified: false,
            });
        case isFulfilled(EMAIL_VERIFY):
            if (action.payload.status === "success") {
                localStorage.setItem("accessToken", action.payload.data.accessToken);
                localStorage.setItem("userId", action.payload?.data?.user?.id);
                return (state = {
                    ...state,
                    emailVerifyLoading: false,
                    emailVerified: true,
                });
            } else {
                return (state = {
                    ...state,
                    emailVerifyLoading: false,
                    emailVerified: false,
                    emailVerificationFailed: true,
                });
            }
        case isPending(FACEBOOK_LOGIN):
            return (state = {
                ...state,
                facebookLogedIn: false,
                facebookLoginLoading: true,
            });
        case isRejected(FACEBOOK_LOGIN):
            return (state = {
                ...state,
                facebookLogedIn: false,
                facebookLoginLoading: false,
            });
        case isFulfilled(FACEBOOK_LOGIN):
            if (action.payload.status === "success") {
                localStorage.setItem("accessToken", action.payload.data.accessToken);
                localStorage.setItem("userId", action.payload.data.user.id);

                return (state = {
                    ...state,
                    facebookLogedIn: true,
                    facebookLoginLoading: false,
                });
            } else {
                return (state = {
                    ...state,
                    facebookLogedIn: false,
                    facebookLoginLoading: false,
                });
            }

        case isPending(LINKEDIN_LOGIN):
            return (state = {
                ...state,
                linkedinLogedIn: false,
                linkedinLoginLoading: true,
            });
        case isRejected(LINKEDIN_LOGIN):
            return (state = {
                ...state,
                linkedinLogedIn: false,
                linkedinLoginLoading: false,
            });
        case isFulfilled(LINKEDIN_LOGIN):
            if (action.payload.status === "success") {
                localStorage.setItem("accessToken", action.payload.data.accessToken);
                localStorage.setItem("userId", action.payload.data.user.id);
                return (state = {
                    ...state,
                    linkedinLogedIn: true,
                    linkedinLoginLoading: false,
                });
            } else {
                return (state = {
                    ...state,
                    linkedinLogedIn: false,
                    linkedinLoginFailed: true,
                    linkedinLoginLoading: false,
                });
            }
        case isPending(GOOGLE_LOGIN):
            return (state = {
                ...state,
                googleLogedIn: false,
                googleLoginLoading: true,
            });
        case isRejected(GOOGLE_LOGIN):
            return (state = {
                ...state,
                googleLogedIn: false,
                googleLoginLoading: false,
            });
        case isFulfilled(GOOGLE_LOGIN):
            if (action.payload.status === "success") {
                localStorage.setItem("accessToken", action.payload.data.accessToken);
                localStorage.setItem("userId", action.payload.data.user.id);
                return (state = {
                    ...state,
                    googleLogedIn: true,
                    googleLoginLoading: false,
                });
            } else {
                return (state = {
                    ...state,
                    googleLogedIn: false,
                    googleLoginLoading: false,
                });
            }

        case isFulfilled("GET_GMB_TOKEN"):
            // console.log("hellotoken", action.payload);
            // console.log("hellotoken", action.payload);
            return {
                ...state,
                gmbAccesstoken: action.payload.data.access_token,
                gmbScope: action.payload.data.scopes,
                gmbExpireTime: action.payload.data.access_token_expires_in,
                gmbRefreshToken: action.payload.data.refresh_token,
            };
        case isFulfilled("GET_GMB_ACCOUNT"):
            // console.log("sfasdfsdasdafsadfdsdf 1", action.payload);
            return { ...state, gmbAccountList: action.payload };

        case isFulfilled("GET_GMB_LOCATION"):
            console.log("sfasdfsdasdafsadfdsdf 2", action.payload);
            return { ...state, gmbLocationList: action.payload };

        // case isFulfilled("GET_GMB_STORE_TOKEN"):
        //     console.log("sfasdfsdasdafsadfdsdf", action.payload);
        //     return { ...state, gmbAddresLine: action.payload };

        case isFulfilled("GET_PLAY_STORE_TOKEN"):
            // console.log("hellotoken play store", action.payload);
            return {
                ...state,
                playStoreAccesstoken: action.payload.data.access_token,
                playStoreScope: action.payload.data.scopes,
                playStoreExpireTime: action.payload.data.access_token_expires_in,
                playStoreRefreshToken: action.payload.data.refresh_token,
            };

        case "SET_PLAYSTORE_CLIENT_DETAILS":
            return {
                ...state,
                playstoreClientSecret: action.payload.playstoreClientSecret,
                playstoreClientId: action.payload.playstoreClientId,
            };

        case isFulfilled("GET_YOUTUBE_TOKEN"):
            return {
                ...state,
                youtubeAccesstoken: action.payload.data.access_token,
                youtubeScope: action.payload.data.scopes,
                youtubeExpireTime: action.payload.data.access_token_expires_in,
                youtubeRefreshToken: action.payload.data.refresh_token,
            };

        case isFulfilled("GET_YOUTUBE_ACCOUNT"):
            return { ...state, youtubeChannelLists: action.payload };

        case isPending(SEND_OTP): {
            return {
                signUpLoading: true,
            };
        }
        case isFulfilled(SEND_OTP): {
            if (action.payload.status === "success") {
                return { ...state, otpSent: true, signUpLoading: false };
            } else {
                return { ...state, signUpLoading: false };
            }
        }
        case SET_OTP_SENT: {
            return {
                ...state,
                otpSent: false,
            };
        }

        default:
            return state;
    }
};

export default authReducer;
